/*项目申报附件*/
import {apiRequest} from "@/api/api";

//--------------------------------------申报附件数据

/*获取项目类型对应的附件列表*/
export function getApplyAttachList(config) {
   config.method = 'get'
   config.url = '/project/PaData/getAttachList'
   apiRequest(config);
}

/* 按照阶段获取项目的附件列表 */
export function getApplyAttachListStage(config){
   config.method = 'get'
   config.url = '/project/PaData/getAttachListStage'
   apiRequest(config);
}

/*获取项目已上传的附件列表*/
export function getPrjUploadFiles(config) {
   config.method = 'get'
   config.url = '/project/PaData/getUploadFiles'
   apiRequest(config);
}

/*文件上传之后,提交文件信息*/
export function uploadFiles(config) {
   config.method = 'post'
   config.formData = true
   config.url = '/project/PaData/uploadFiles'
   apiRequest(config)
}

/*通过路径删除已上传的文件*/
export function deleteUploadFiles(config) {
   config.method = 'post'
   config.formData = true
   config.url = '/project/PaData/deleteByPath'
   apiRequest(config)
}